<!-- components/BackendPagination.vue -->
<template>
    <ArgonPagination color="success" size="sm" class="mt-3 d-flex justify-content-center">
      <ArgonPaginationItem
        :disabled="currentPage === 1"
        prev
        @click="$emit('change-page', currentPage - 1)"
      />
  
      <ArgonPaginationItem
        v-for="page in pagesToShow"
        :key="page"
        :label="String(page)"
        :active="page === currentPage"
        @click="$emit('change-page', page)"
      />
  
      <ArgonPaginationItem
        :disabled="currentPage === totalPages"
        next
        @click="$emit('change-page', currentPage + 1)"
      />
    </ArgonPagination>
  </template>
  
  <script setup>
  import { computed } from "vue";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  
  const props = defineProps({
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    maxVisiblePages: {
      type: Number,
      default: 5, // Optional prop to limit pagination length
    },
  });
  
  defineEmits(["change-page"]);
  
  const pagesToShow = computed(() => {
    const pages = [];
    const half = Math.floor(props.maxVisiblePages / 2);
    let start = Math.max(1, props.currentPage - half);
    let end = Math.min(props.totalPages, start + props.maxVisiblePages - 1);
  
    // Adjust start if end is near totalPages
    if (end - start < props.maxVisiblePages - 1) {
      start = Math.max(1, end - props.maxVisiblePages + 1);
    }
  
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
  
    return pages;
  });
  </script>
  